<template>
  <vs-card class="w-full collapse-cstm-card">
    <!-- <pre> {{ lessonAssignment }}</pre> -->
    <vs-collapse 
    v-for="(eachAssignment,index) in lessonAssignment" :key="index"
    >
      <vs-collapse-item>
        <div slot="header">{{eachAssignment.assignment.title}}</div>
        <!-- {{eachAssignment}}
<pre>{{eachAssignment.assignment.questions}}</pre> -->
        <question-modal
          :QuestionModal="eachAssignment.assignment.questions"
          Modaltype="assignment"
          :lessonId="eachAssignment.lesson_id"
          :course_id="eachAssignment.course_id"
          :sectionType="sectionType"

        ></question-modal>

        
      </vs-collapse-item>
    </vs-collapse>
  </vs-card>
</template>
<script>
import QuestionModal from './QuestionModal.vue'

export default {
  name: 'AssignmentModal',
  components: {
    QuestionModal
  },
  props: {
    lessonAssignment: {
      type: Array,
      required: true,
      default: () => []
    },
    sectionType:{
      type:Number,
      default:null
    }
  }
}
</script>